<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                  <img src="static/img/authentic_net_lt_color.png" width="400" alt="Authentic.net">
                  <h3>Please wait. You will be redirected...</h3>
                  <hr>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright text-center">
              &copy; Copyright 2019 Authentic.net
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link to="/login">
            Looking to login?
          </router-link>
        </li>
      </ul>
    </div>

  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import firebase from 'firebase'

  export default {
    data () {
      return {
        loading: false,
        authMode: ''
      }
    },
    methods: {
      init () {
        console.log(this.$route.query)
        this.authMode = this.$route.query.mode
        if (this.authMode === 'resetPassword') {
          firebase.auth().verifyPasswordResetCode(this.$route.query.oobCode)
          .then(email => {
            this.$router.replace('/reset-password/' + this.$route.query.oobCode)
          })
          .catch(error => {
            swal.fire({
              title: `Error`,
              text: error.message + ' Please attempt to reset your password again if needed or contact support.',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              type: 'error'
            }).then(() => {
              this.loading = false
              this.$router.replace('/login')
            })
          })
        } else if (this.authMode === 'signIn') {
          // Confirm the link is a sign-in with email link.
          // this.$route.query.fullPath
          if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
            // Additional state parameters can also be passed via URL.
            // This can be used to continue the user's intended action before triggering
            // the sign-in operation.
            // Get the email if available. This should be available if the user completes
            // the flow on the same device where they started it.
            var email = window.localStorage.getItem('emailForSignIn')
            if (!email) {
              // User opened the link on a different device. To prevent session fixation
              // attacks, ask the user to provide the associated email again. For example:
              email = window.prompt('Please provide your email for confirmation')
            }
            // The client SDK will parse the code from the link for you.
            firebase.auth().signInWithEmailLink(email, window.location.href)
              .then((result) => {
                console.log('sign in worked')
                console.log(result)
                // Clear email from storage.
                window.localStorage.removeItem('emailForSignIn')
                // You can access the new user via result.user
                // Additional user info profile not available via:
                // result.additionalUserInfo.profile == null
                // You can check if the user is new or existing:
                // result.additionalUserInfo.isNewUser
                if (!result.user.phoneNumber) {
                  this.$router.replace({ name: 'Onboarding' })
                } else {
                  // this.$router.replace(this.$route.query.continueUrl || { name: 'Dashboard' })
                  this.$router.replace({ name: 'Dashboard' })
                }
              })
              .catch((error) => {
                // Some error occurred, you can inspect the code: error.code
                // Common errors could be invalid email and invalid or expired OTPs.
                console.log(error)
              })
          }
        }
      },
      async createAccount (userId) {
        try {
          let data = {
            uid: userId,
            model: this.model
          }
          let setupAccount = firebase.functions().httpsCallable('setupAccount')
          setupAccount(data)
          .then(result => {
            if (result.data.success) this.$router.replace(this.$route.query.redirect || { name: 'Onboarding' })
            else {
              swal.fire({
                title: 'Error',
                text: 'Sorry, the following error took place: ' + err.message,
                type: 'error',
                confirmButtonClass: 'btn btn-info btn-fill',
                buttonsStyling: false
              })
              this.loading = false
            }
          })
          .catch(err => {
            console.error(err.message)
          })
        } catch (err) {
          swal.fire({
            title: 'Error',
            text: 'Sorry, the following error took place: ' + err.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          .then(() => {
            this.loading = false
          })
        }
      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      }
    },
    beforeDestroy () {
      this.closeMenu()
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    },
    beforeRouteUpdate (to, from, next) {
      // react to route changes...
      // don't forget to call next()
      next()
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/AuthAction.vue